import React, { FC, PropsWithChildren } from 'react';
import OpDrawer from 'components/Common/op-ui-wrappers/OpDrawer/OpDrawer';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import { useSelector } from 'react-redux';
import getNumberOfAppliedFilters from 'store/category/selector/getNumberOfAppliedFilters';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './FiltersDrawer.module.scss';

interface FiltersDrawerProps {
  visible: boolean;
  onClose: any;
  onShow?: () => void;
  onClear?: () => void;
  showActionButtons?: boolean;
  title?: string;
  fixedHeight?: boolean;
}

const FiltersDrawer: FC<PropsWithChildren<FiltersDrawerProps>> = ({
  onClose,
  onShow,
  visible,
  showActionButtons,
  children,
  onClear,
  title,
  fixedHeight,
}) => {
  const { t } = useTranslation();
  const numberOfAppliedFilters = useSelector(getNumberOfAppliedFilters);
  const showCancel = numberOfAppliedFilters === 0;

  return (
    <OpDrawer visible={visible} onClose={onClose} className={styles.filterDrawer}>
      <div slot="label" className={styles.drawerLabel}>
        <OpText variant="title-medium-bold" className={styles.upperCase}>
          {title}
        </OpText>
      </div>
      <div slot="content" className={cn(styles.content, { [styles.fixedHeight]: fixedHeight })}>
        {children}
      </div>
      {showActionButtons && (
        <div slot="actions" className={styles.drawerActions}>
          <OpButton variant="primary" block onClick={onShow}>
            {t('txt_apply_filters')}
          </OpButton>
          {showCancel && (
            <OpButton variant="secondary" block onClick={onClose}>
              {t('txt_cancel')}
            </OpButton>
          )}
          {!showCancel && (
            <OpButton variant="secondary" block onClick={onClear}>
              <span className={styles.upperCase}>{t('txt_clear_filters')}</span>
            </OpButton>
          )}
        </div>
      )}
    </OpDrawer>
  );
};

export default FiltersDrawer;
